module.exports = "/_next/static/images/8ab2d6846c18f08f96b58b993d762dd3-dress-code-3.png";